import { render } from "./IconTrash.vue?vue&type=template&id=3c0eb676"
import script from "./IconTrash.vue?vue&type=script&lang=js"
export * from "./IconTrash.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__